import { MenuItem, Stack } from "@mui/material";
import { FC, useCallback } from "react";
import { NavLink } from "react-router-dom";
import { useFlag } from "@unleash/proxy-client-react";
import { ProviderIcon } from "@/components/common/ProviderIcon";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { ProviderType } from "@/services/cloudchipr.api";

interface CommitmentsHeaderProviderSelectItemProps {
  provider: ProviderType;
  orgId: string;
  title: string;
  onCommitmentClick(provider: ProviderType): void;
}

export const CommitmentsHeaderProviderSelectItem: FC<
  CommitmentsHeaderProviderSelectItemProps
> = ({ provider, orgId, title, onCommitmentClick }) => {
  const enableReservedInstances = useFlag("EnableReservedInstances");

  const clickHandler = useCallback(() => {
    onCommitmentClick(provider);
  }, [onCommitmentClick, provider]);
  return (
    <MenuItem
      component={NavLink}
      to={
        enableReservedInstances
          ? `/commitments/${provider}/${orgId}`
          : `/commitments/utilization-and-coverage/${orgId}`
      }
      onClick={clickHandler}
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        overflow="hidden"
        py={0.5}
      >
        <ProviderIcon provider={provider} />

        <TypographyWithTooltip variant="body2" lineHeight={1.1} title={title} />
      </Stack>
    </MenuItem>
  );
};
